/* eslint-disable import/no-unresolved */
import React, { useMemo } from 'react'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import TableType3 from 'src/components/sharedComponents/Tablas/TableType3/TableType3'
import SearchFilter from 'src/components/leads/searchFilterLeads'
import LeadsDetails from 'src/components/leads/leadsDetails/LeadsDetails'
import PopupResultLeads from 'src/components/leads/popupResultLeads/PopupResultLeads'

const linkButtonStyle = {
  background: 'none',
  border: 'none',
  color: '#1a73e8',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: 14,
  padding: 0,
}

const LeadPage = (props) => {
  const {
    counters,
    rows,
    rowCount,
    isLoading,
    pagination,
    onPaginationChange,
    globalFilter,
    onGlobalFilterChange,
    rowSelection,
    onRowSelectionChange,
    details,
    detailsPopup,
    listResult,
    ciudades,
    vehiculos,
    marcas,
    openDetails,
    handleChange,
    onOpenDetails,
    openDetailsPopup,
    onOpenDetailsPopup,
    onIntegrate,
    departamentos,
    hiddenIntegration,
    onCloseDetails,
    onCloseDetailsPopupResult,
    handleChangeDepartment,
    handleDateInitChange,
    handleDateEndChange,
    selectedDateInit,
    selectedDateEnd,
    qtyLeads,
    onSelectAllFiltered,
    onClearSelection,
    allFilteredSelected,
    isSelection,
    loadingPopups,
  } = props

  // total de leads NO integrados que cumplen los filtros vigentes (lo da el backend)
  const totalNoIntegrados = counters?.no_integrados ?? 0
  // hay seleccion de pagina y existen mas no-integrados en otras paginas => ofrecer "seleccionar todos"
  const ofrecerSeleccionarTodos =
    !allFilteredSelected && qtyLeads > 0 && totalNoIntegrados > qtyLeads

  const columnsLeads = useMemo(
    () => [
      {
        accessorKey: 'actions',
        header: 'VER',
        size: 70,
        enableSorting: false,
        Cell: ({ row }) => (
          <div
            onClick={() => onOpenDetails(row.original)}
            style={{ textAlign: 'center' }}
          >
            <img
              src="https://media.autecomobility.com/recursos/imagenes/view-lead.png"
              style={{ width: 32, cursor: 'pointer' }}
              alt="Ver lead"
            />
          </div>
        ),
      },
      { accessorKey: 'nombre_establecimiento', header: 'ESTABLECIMIENTO', size: 200 },
      { accessorKey: 'campana', header: 'CAMPAÑA', size: 190 },
      { accessorKey: 'marca', header: 'MARCA', size: 120 },
      { accessorKey: 'vehiculo', header: 'VEHICULO', size: 170 },
      { accessorKey: 'ciudad', header: 'CIUDAD', size: 140 },
      { accessorKey: 'departamento', header: 'DEPARTAMENTO', size: 160 },
      { accessorKey: 'documento', header: 'DOCUMENTO', size: 130 },
      { accessorKey: 'correo_electronico', header: 'CORREO', size: 220 },
      {
        accessorKey: 'fecha_creacion',
        header: 'FECHA',
        size: 120,
        Cell: ({ cell }) => cell.getValue()?.slice(0, 10) ?? '',
      },
      { accessorKey: 'origen', header: 'ORIGEN', size: 140 },
    ],
    [onOpenDetails],
  )

  return (
    <>
      <CardTitle title="Gestión de Leads" />

      <SearchFilter
        counters={counters}
        title="Leads"
        vehiculos={vehiculos}
        marcas={marcas}
        ciudades={ciudades}
        handleChange={handleChange}
        departamentos={departamentos}
        handleChangeDepartment={handleChangeDepartment}
        handleDateInitChange={handleDateInitChange}
        handleDateEndChange={handleDateEndChange}
        selectedDateInit={selectedDateInit}
        selectedDateEnd={selectedDateEnd}
        qtyLeads={qtyLeads}
      />

      {qtyLeads > 0 && (
        <div
          style={{
            margin: '8px 0',
            padding: '8px 14px',
            borderRadius: 6,
            backgroundColor: allFilteredSelected ? '#e8f0fe' : '#fff8e1',
            border: `1px solid ${allFilteredSelected ? '#aecbfa' : '#ffe082'}`,
            fontSize: 14,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
          }}
        >
          <span>
            <strong>{qtyLeads}</strong>{' '}
            {qtyLeads === 1 ? 'lead seleccionado' : 'leads seleccionados'} para
            integrar
            {allFilteredSelected ? ' (todas las páginas)' : ''}.
          </span>

          {ofrecerSeleccionarTodos && (
            <button
              type="button"
              onClick={onSelectAllFiltered}
              style={linkButtonStyle}
            >
              Seleccionar los {totalNoIntegrados} leads no integrados de todas las
              páginas
            </button>
          )}

          <button type="button" onClick={onClearSelection} style={linkButtonStyle}>
            Limpiar selección
          </button>
        </div>
      )}

      <TableType3
        columns={columnsLeads}
        data={rows}
        rowCount={rowCount}
        isLoading={isLoading}
        pagination={pagination}
        onPaginationChange={onPaginationChange}
        globalFilter={globalFilter}
        onGlobalFilterChange={onGlobalFilterChange}
        rowSelection={rowSelection}
        onRowSelectionChange={onRowSelectionChange}
        totalSelected={qtyLeads}
        hiddenIntegration={hiddenIntegration}
        onIntegrate={onIntegrate}
        isSelection={isSelection}
      />

      <LeadsDetails
        details={details}
        openDetails={openDetails}
        onCloseDetails={onCloseDetails}
      />

      <PopupResultLeads
        loadingPopups={loadingPopups}
        detailsPopup={detailsPopup}
        openDetailsPopup={openDetailsPopup}
        onOpenDetailsPopup={onOpenDetailsPopup}
        listResult={listResult}
        onCloseDetailsPopupResult={onCloseDetailsPopupResult}
      />
    </>
  )
}

export default LeadPage
